<div>
  @if (!type) {
    <input
      #messageInput
      [id]="inputID ? inputID : ''"
      (blur)="blur.next(true)"
      [type]="type"
      [class]="class"
      [placeholder]="placeholder"
      [(ngModel)]="message"
      (keydown)="keyDownEvent($event)"
      (keyup)="keyUpEvent($event)"
      (paste)="contentPasted($event)"
    />
  }
  @if (type == "textarea") {
    <textarea #messageInput [id]="inputID ? inputID : null" [class]="class" [placeholder]="placeholder" [(ngModel)]="message" (keydown)="keyDownEvent($event)" (keyup)="keyUpEvent($event)"></textarea>
  }

  @if (type == "span") {
    <div
      #container
      class="editable-message-span-container"
      [class.include-border-top]="backgroundColor == 'transparent'"
      [ngStyle]="{ 'background-color': backgroundColor, 'border-radius': backgroundColor != 'transparent' ? '10px' : '0px' }"
    >
      @if (!useQuill) {
        <span
          id="comment"
          role="textbox"
          [attr.aria-label]="ariaLabelBy ? null : 'message'"
          [attr.aria-labelledby]="ariaLabelBy ? ariaLabelBy : null"
          [attr.aria-describedby]="ariaDescribedBy ? ariaDescribedBy : null"
          #messageSpan
          [id]="inputID ? inputID : 'input_span'"
          class="editable-message-span"
          (keyup)="keyUpEvent($event)"
          (keydown)="keyDownEvent($event)"
          (paste)="contentPasted($event)"
          (focusin)="focusIn($event)"
          (focusout)="focusOut($event)"
          contenteditable
          [ngStyle]="{ 'margin-right': spanMarginRight + 'px' }"
          [innerText]=""
          [attr.data-placeholder]="placeholder"
        ></span>
      }
      @if (useQuill) {
        <div class="w-full quill-container">
          <div [id]="'qe_' + inputID"></div>
          <div [id]="'qt_' + inputID"></div>
        </div>
      }
      <div class="d-flex send-btn-container">
        @if (includeAttachmentButton) {
          <img src="./assets/icons/workspace-upload.png" (click)="attachmentBtnClicked.next()" class="attach-btn in-input" placement="top" [ngbTooltip]="'sphere.workspaces.share_file' | translate" />
        }
        @if (includeSendButton) {
          <button type="button" class="p-0" (click)="send()" (keyup.enter)="send()" aria-label="send">
            @if (!sendButtonLoading) {
              <fa-icon icon="arrow-alt-circle-up" class="send-icon" aria-hidden="true"></fa-icon>
            }
            @if (sendButtonLoading) {
              <fa-icon icon="spinner" animation="spin" class="send-icon" aria-hidden="true"></fa-icon>
            }
            <span class="sr-only">send</span>
          </button>
        }
      </div>
    </div>
  }
  @if (elligibleMentions && elligibleMentions.length) {
    @for (user of elligibleMentions; track user) {
      <div class="mention-option d-flex m-y-10 align-items-center" [class.selected]="user.selected" (click)="selectMention(user)">
        <img [src]="user.photo || './assets/images/default_avatar.jpg'" class="profile-photo tiny m-r-5" />
        <span class="bold t-14">{{ user.name ? user.name : user.firstName + " " + user.lastName }}</span>
      </div>
    }
  }
</div>
